import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import useEditorPreference from '../../../helpers/useEditorPreference';

// Self-contained on purpose: the rest of Settings.js is a Query/Mutation
// render-prop tree, and the editor preference already has a hook that owns its
// local mirror and its three-state default. Threading it through the existing
// machinery would duplicate that logic in a second place.
export default function EditorVersionToggle() {
  const { useV2, setUseV2, loading } = useEditorPreference();

  return (
    <>
      <FormControlLabel
        labelPlacement="end"
        control={
          <Switch
            checked={useV2}
            disabled={loading}
            onChange={event => setUseV2(event.target.checked)}
            value="useEditorV2"
            color="primary"
          />
        }
        label="Use the visual post editor"
      />
      <span className="tw-mb-2 tw-ml-14 tw--mt-1 tw-block tw-text-xs tw-text-gray-500">
        Photo galleries, maps, tables, AI and SEO built in.
      </span>
    </>
  );
}
